import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';

import { AuthTokenService } from './auth-token.service';

/**
 * Route guard: requires a valid OAuth session.
 *
 * Unauthenticated users are sent to `/login` (a landing page with a Sign-in
 * button) rather than being kicked straight into the Keycloak redirect.
 * Login is enforced in every environment.
 */
export const authGuard = ((
  _route?: ActivatedRouteSnapshot,
  _state?: RouterStateSnapshot,
): boolean | UrlTree => {
  const tokens = inject(AuthTokenService);
  if (tokens.isAuthenticated) {
    return true;
  }
  const router = inject(Router);
  return router.parseUrl('/login');
}) satisfies CanActivateFn;
